import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_CHANGE_TASK_DETAIL_BEGIN,
  SCHEDULE_CHANGE_TASK_DETAIL_SUCCESS,
  SCHEDULE_CHANGE_TASK_DETAIL_FAILURE,
  SCHEDULE_CHANGE_TASK_DETAIL_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function changeTaskDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_CHANGE_TASK_DETAIL_BEGIN,
    });
    const { values, projectId, taskId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/${taskId}`;
      const doRequest = axios.put(url, values, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_CHANGE_TASK_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_CHANGE_TASK_DETAIL_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Updation Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeTaskDetailError() {
  return {
    type: SCHEDULE_CHANGE_TASK_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_CHANGE_TASK_DETAIL_BEGIN:
      return {
        ...state,
        changeTaskDetailPending: true,
        changeTaskDetailError: null,
      };

    case SCHEDULE_CHANGE_TASK_DETAIL_SUCCESS:
      return {
        ...state,
        changeTaskDetailPending: false,
        changeTaskDetailError: null,
        taskDetail: action.data.schedule,
      };

    case SCHEDULE_CHANGE_TASK_DETAIL_FAILURE:
      return {
        ...state,
        changeTaskDetailPending: false,
        changeTaskDetailError: action.data.error,
      };

    case SCHEDULE_CHANGE_TASK_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        changeTaskDetailError: null,
      };

    default:
      return state;
  }
}
